module.exports = __webpack_public_path__ + "static/media/video-icon.2575dd7f.png";